import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckRounded = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.0028 18.6209C14.7635 18.6209 18.6228 14.7616 18.6228 10.0009C18.6228 5.24016 14.7635 1.38086 10.0028 1.38086C5.24212 1.38086 1.38281 5.24016 1.38281 10.0009C1.38281 14.7616 5.24212 18.6209 10.0028 18.6209Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.14844 10.5517L8.45244 12.8557L14.2124 7.0957",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCheckRounded;
